import React from 'react';
import Icon from '../../../components/AppIcon';

const TableOfContents = () => {
  const sections = [
    { id: 'information-collection', title: 'Information We Collect' },
    { id: 'information-use', title: 'How We Use Your Information' },
    { id: 'information-sharing', title: 'Information Sharing' },
    { id: 'data-security', title: 'Data Security' },
    { id: 'cookies-tracking', title: 'Cookies & Tracking' },
    { id: 'user-rights', title: 'Your Rights & Choices' },
    { id: 'data-retention', title: 'Data Retention' },
    { id: 'third-party-services', title: 'Third-Party Services' },
    { id: 'children-privacy', title: 'Children\'s Privacy' },
    { id: 'policy-changes', title: 'Policy Changes' },
    { id: 'contact-us', title: 'Contact Us' }
  ];

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <div className="bg-white rounded-xl p-6 border border-border sticky top-24">
      <h3 className="text-lg font-jakarta font-semibold text-text-primary mb-4 flex items-center">
        <Icon name="List" size={20} className="text-primary mr-2" />
        Table of Contents
      </h3>
      <nav className="space-y-2">
        {sections?.map((section) => (
          <button
            key={section?.id}
            onClick={() => scrollToSection(section?.id)}
            className="block w-full text-left text-sm text-text-secondary hover:text-primary transition-colors duration-200 py-1 px-2 rounded hover:bg-surface"
          >
            {section?.title}
          </button>
        ))}
      </nav>
    </div>
  );
};

export default TableOfContents;